"use client";

import { useMemberJobsNavVisible } from "@/hooks/useJobsNav";
import { useUniversityLinkStatus, useUniversityLinkVisible } from "@/hooks/useUniversityLink";
import type { NavVisibilityContext } from "@/components/layout/memberNavItems";

// 会員向けグローバルナビの表示条件をまとめて解決する。
// AppSidebar / Header / BottomNav の3箇所が同じ描画でこれを呼び、getVisibleMemberNavItems へ渡す。
// 表示条件を足すときはここと memberNavItems.tsx だけを直せばよく、3箇所のどれかで渡し忘れて
// 項目が黙って消えることがない。
export function useMemberNavVisibility(): NavVisibilityContext {
  // 高校生には求人と、その下流の応募状況の導線を出さない（#1749）
  const jobsNavVisible = useMemberJobsNavVisible();
  // 大学連携は大学の名簿に一致する学生にだけ出す（#1861）
  const universityLinkVisible = useUniversityLinkVisible();
  // 大学へのデータ共有が有効なら大学連携に「共有中」のバッジを付ける（#1861）
  const universitySharing = useUniversityLinkStatus().status?.sharing === true;
  return { jobsNavVisible, universityLinkVisible, universitySharing };
}
